import { createContext, useContext } from 'react';

import type { RenderCloseAccountAction } from './contentTypes';
import type { AccountSettingsAccount } from './data';

type AccountSettingsContextValue = {
  account?: AccountSettingsAccount;
  isEditable: boolean;
  handleNameUpdate?: (newName?: string) => Promise<void>;
  renderCloseAccount?: RenderCloseAccountAction;
};

const AccountSettingsContext = createContext<AccountSettingsContextValue>({ isEditable: true });

export const AccountSettingsProvider = AccountSettingsContext.Provider;

export const useAccountSettings = () => useContext(AccountSettingsContext);
